module.exports = __webpack_public_path__ + "static/media/percentage.3f86fe65.svg";